module.exports = __webpack_public_path__ + "static/media/sleep.9e152b90.png";